module.exports = __webpack_public_path__ + "static/dfocusLogo.9ee1d43c.svg";